import React from 'react';
import { DatePicker } from '@td-client-frontend/common';
import ComponentWrapperRHF from './ComponentWrapperRHF';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  wrapperClasses?: string;
  minDate?: Date;
  required?: boolean;
  disabled?: boolean;
  readOnlyFieldFormatter?: (value: any) => void;
}

export const DatePickerRhf = ({ ...props }: Props) => {
  return (
    <ComponentWrapperRHF {...props}>
      <DatePicker />
    </ComponentWrapperRHF>
  );
};
